export default __webpack_public_path__ + "static/media/culture_pinpoint.69304998.svg";